import { CalendarCheck, Phone } from "lucide-react";
import "./badge.css";

export const INTENT_META = {
  site_visit_request: {
    label: "Site Visit",
    className: "intent-site-visit",
    icon: CalendarCheck,
  },
  callback_request: {
    label: "Callback",
    className: "intent-callback",
    icon: Phone,
  },
};

export default function IntentBadge({ intent }) {
  const meta = INTENT_META[intent];

  if (!meta) {
    return <span className="intent-badge intent-badge-empty">—</span>;
  }

  const Icon = meta.icon;

  return (
    <span className={`intent-badge ${meta.className}`}>
      <Icon size={12} strokeWidth={2.25} />
      <span className="intent-badge-label">{meta.label}</span>
    </span>
  );
}
